export const Theme = {
  primary: "#3CB2EE",
  primaryDark: "#0290D8",
  secondary: "#81C153",
  secondaryDark: "#68AC38",
  background: "#fafafa",
  borderInput: "#b5b5b5",
  cardShadow: {
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },
  flexView: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  font: { small: "12px", medium: "14px", large: "24px" },
};
